import { createTheme } from "@mui/material";
import "../../constants/scss/fonts/DefaultFonts.scss";

export const notificationButtonsTheme = createTheme({
  components: {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#ddd",
          color: "#000",
          paddingLeft: "0px",
          paddingRight: "0px",
          "&.Mui-selected": {
            backgroundColor: "#000",
            color: "#fff",
            fontWeight: "bold",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "#222",
          },
          "&:hover": {
            backgroundColor: "#71706f",
            color: "white",
          },
        },
      },
    },
  },
});
